import { Component } from "preact";
import actions from "../../actions";
import { connectWithTranslations } from "../../../common/helpers/translationsHelpers";
import IconInfoCircle from "../../../common/components/icons/IconInfoCircle";
import IconCogSolid from "../../../common/components/icons/IconCogSolid";
import { GTM_ID, GA4EVENT } from "../../constants";
import AdvancedFilter from "./advanced/AdvancedFilter";
import TimezonePicker from "./common/TimezonePicker";
import DownloadFilter from "./common/DownloadFilter";
import TimeFilter from "./common/TimeFilter";
import IconTimes from "../../../common/components/icons/IconTimes";
import IconAngleDoubleRight from "../../../common/components/icons/IconAngleDoubleRight";
import SoundAlert from "../../../calendar-common/components/SoundAlert";
import ConfigureView from "../../../calendar-common/components/ConfigureView";
import { persistSettings } from "../../../calendar-common/helpers/settingsHelper";
import { CALENDAR_VIEW, FILTER_TYPE } from "../../../calendar-common/constants";
import ConfirmationPopUp from "../../../calendar-common/components/ConfirmationPopUp";
import { enabledCalendarNotifications } from "../../../calendar-common/helpers/calendar";

class DesktopFilter extends Component {
    constructor(props) {
        super(props);

        this.onTimezoneChanged = this.onTimezoneChanged.bind(this);
        this.toggleAdvancedFilter = this.toggleAdvancedFilter.bind(this);

        this.state = {
            notificationSoundOn: false,
            view: 0,
            showPopUp: false,
            actualViewSelected: 0,
        };
    }
    componentWillMount() {
        this.props.updateSettingsFromStorage();
        this.setState({
            notificationSoundOn: this.props.settings.notificationSoundOn,
            view: this.props.settings.view,
            actualViewSelected: this.props.settings.view,
            showPopUp: false,
        });
    }
    onTimezoneChanged(timezone) {
        this.props.changeTimezoneAndFetch(timezone);

        var timezoneOffset = timezone.OffsetValue;
        persistSettings({ timezoneOffset });
    }

    onNotificationSoundChange() {
        this.props.changeSettingsAndSave({
            notificationSoundOn: !this.props.settings.notificationSoundOn,
        });
        persistSettings({
            notificationSoundOn: !this.props.settings.notificationSoundOn,
        });
    }

    onOptionChange(option) {
        const { settings } = this.props;
        if (
            option != CALENDAR_VIEW.Configure_View_Premium &&
            settings.filter.type != FILTER_TYPE.custom
        ) {
            this.props.changeSettingsAndSave({ view: option });
        } else {
            this.setState({ showPopUp: true, actualViewSelected: option });
        }
    }

    toggleAdvancedFilter() {
        this.props.changeShowAdvancedFilter(!this.props.showAdvancedFilter);
    }

    close() {
        this.setState({
            showPopUp: false,
            actualViewSelected: this.state.view,
        });
    }

    applyOption(option) {
        this.props.changeSettingsAndSave({ view: option });
        this.setState({ showPopUp: false });
        this.props.showSucessMessage();
    }

    render(
        {
            config,
            settings,
            translate,
            showAdvancedFilter,
            notificationsSupported,
            toggleModalLegend,
            onChangeFilter,
            onChangeFilterDateRange,
            onChangeCustomFilter,
            onApplyRange,
            showSuccessMessage,
        },
        { showPopUp, actualViewSelected }
    ) {
        return (
            <div class="fxs_c_desktop-filters">
                {showSuccessMessage && (
                    <div
                        class="fxs_contextual_alert fxs_alert_success alert alert-dismissible fade in"
                        role="alert"
                    >
                        <p class="fxs_alertText">
                            {translate("Success_Message")}
                        </p>
                    </div>
                )}
                {showPopUp && (
                    <div
                        class="fxs_cs_modal"
                        tabindex="-1"
                        role="dialog"
                        aria-hidden="true"
                    >
                        <div class="fxs_cs_modal_content fxs_cs_modal_content_advice">
                            <button
                                type="button"
                                onClick={() => this.close()}
                                class="fxs_modal_close fxs_btn_icon close fxs_cs_modal_close"
                                data-dismiss="modal"
                                aria-label="Close Modal"
                                data-gtmid={ config.tracking && GTM_ID.CONFIGURATION_CLOSE }
                                data-ga4event-clk-name={config.tracking && GA4EVENT.NAMES.FEATURES_CALENDAR}
                                data-ga4event-element = {config.tracking && GA4EVENT.ELEMENTS.CONFIGURATION_CLOSE}

                            >
                                <IconTimes />
                                <span class="fxs_skip">Close</span>
                            </button>
                            <ConfirmationPopUp
                                cancel={() => this.close()}
                                save={() =>
                                    this.applyOption(actualViewSelected)
                                }
                            ></ConfirmationPopUp>
                        </div>
                    </div>
                )}
                {showAdvancedFilter && <div class="fxs_c_modal-backdrop"></div>}
                {showAdvancedFilter && (
                    <AdvancedFilter
                        filter={settings.filter}
                        onTimeFilterChanged={(time) => onChangeFilter({ time })}
                    />
                )}

                <TimeFilter
                    time={settings.filter.time}
                    dateRange={settings.filter.dateRange}
                    onTimeFilterChanged={(time) => onChangeFilter({ time })}
                    applyFilter={(dateRange) => onApplyRange({ dateRange })}
                    onDateRangeFilterChanged={(dateRange) =>
                        onChangeFilterDateRange({ dateRange })
                    }
                    onChangeCustomFilter={onChangeCustomFilter}
                    getCalendarTimeOptionGtmId={(time) =>
                        config.tracking &&
                        GTM_ID.DATEPIKER_OPTION(time.replace("TimeFilter_", ""))
                    }
                    getCalendarTimeOptionGa4Id={(time) =>
                        config.tracking &&
                        GA4EVENT.ELEMENTS.DATEPIKER_OPTION(time.replace("TimeFilter_", ""))
                    }
                    getCalendarButtonGtmId={
                        config.tracking && GTM_ID.DATEPIKER_TIMESELECTOR_BUTTON
                    }
                    getCalendarButtonGa4Id={
                        config.tracking && GA4EVENT.ELEMENTS.DATEPIKER_TIMESELECTOR_BUTTON
                    }
                    getGa4Name={
                        config.tracking && GA4EVENT.NAMES.FEATURES_CALENDAR
                    }

                />

                <TimezonePicker
                    onTimezoneChanged={this.onTimezoneChanged}
                    currentTimezone={settings.timezoneOffset}
                />

                <div class="fxs_fRight">
                    <button
                        type="button"
                        class="fxs_btn fxs_btn_icon fxs_btn_xsmall fxs_fLeft fxs_btn_legend fxs_btn_phantom"
                        data-gtmid={ config.tracking && GTM_ID.CONFIGURATION_HELP }
                        data-ga4event-clk-name={config.tracking && GA4EVENT.NAMES.FEATURES_CALENDAR}
                        data-ga4event-element = {config.tracking && GA4EVENT.ELEMENTS.CONFIGURATION_HELP}
                        onClick={toggleModalLegend}
                    >
                        <IconInfoCircle />
                    </button>
                    <DownloadFilter />
                    <div class="fxs_c_configuration_rollover_trigger">
                        <button
                            type="button"
                            onClick={() => this.props.openCalendarSettings()}
                            data-gtmid={ config.tracking && GTM_ID.CONFIGURATION_GEAR }
                            data-ga4event-clk-name={config.tracking && GA4EVENT.NAMES.FEATURES_CALENDAR}
                            data-ga4event-element = {config.tracking && GA4EVENT.ELEMENTS.CONFIGURATION_GEAR}
                            class="fxs_btn fxs_btn_table_filter fxs_btn_xsmall fxs_fLeft fxs_btn_legend"
                        >
                            <IconCogSolid />
                        </button>
                        <div class="fxs_c_configuration_rollover">
                            <div class="fxs_c_configuration_rollover_main">
                                <SoundAlert
                                    onCheckboxChanged={() =>
                                        this.onNotificationSoundChange()
                                    }
                                    notificationSoundOn={
                                        settings.notificationSoundOn
                                    }
                                    locale={this.props.config.culture}
                                ></SoundAlert>
                                <ConfigureView
                                    view={settings.view}
                                    onOptionSelected={(option) =>
                                        this.onOptionChange(option)
                                    }
                                    showDescription={false}
                                    locale={this.props.config.culture}
                                ></ConfigureView>
                            </div>
                            <footer class="fxs_c_configuration_rollover_footer">
                                <h4 class="fxs_headline_tiny fxs_fLeft">
                                    {enabledCalendarNotifications(config)
                                        ? translate("NotificationsLabel")
                                        : ""}
                                </h4>
                                <a
                                    onClick={() =>
                                        this.props.openCalendarSettings()
                                    }
                                    class="fxs_fRight"
                                    data-gtmid={ config.tracking && GTM_ID.CONFIGURATION_MANAGE_EVENT_LIST }
                                    data-ga4event-clk-name={config.tracking && GA4EVENT.NAMES.FEATURES_CALENDAR}
                                    data-ga4event-element = {config.tracking && GA4EVENT.ELEMENTS.CONFIGURATION_MANAGE_EVENT_LIST}
                                >
                                    {enabledCalendarNotifications(config)
                                        ? translate("ManageEventList")
                                        : translate("ViewMore")}
                                    <IconAngleDoubleRight />
                                </a>
                            </footer>
                        </div>
                    </div>
                    <button
                        type="button"
                        onClick={() => this.toggleAdvancedFilter()}
                        data-gtmid={config.tracking && GTM_ID.FILTER_ADVANCED}
                        class={`fxs_btn fxs_btn_xsmall fxs_btn_default fxs_c_filters_trigger ${
                            this.props.showAdvancedFilter
                                ? "fxs_c_filters_trigger_active"
                                : ""
                        }`}
                        data-ga4event-clk-name={config.tracking && GA4EVENT.NAMES.FEATURES_CALENDAR}
                        data-ga4event-element = {config.tracking && GA4EVENT.ELEMENTS.FILTER_ADVANCED}
                    >
                        <span>
                            <span>{translate("AdvancedFilterLabel")}</span>
                        </span>
                    </button>
                </div>
                {settings.filter.eventName && (
                    <div class="fxs_c_filter_event_name">
                        <span class="fxs_c_filter_event_name_label">
                            {translate("ResultsFor")}
                        </span>{" "}
                        <span class="fxs_c_filter_event_name_badge">
                            <span class="fxs_c_filter_event_name_name">
                                {settings.filter.eventName}
                            </span>
                            <buttom
                                class="fxs_btn fxs_c_filter_event_name_close_button"
                                onClick={() => {
                                    onChangeFilter({ eventName: null });
                                    this.props.fetchEventDates();
                                }}
                            >
                                <IconTimes />
                            </buttom>
                        </span>
                    </div>
                )}
            </div>
        );
    }
}

export default connectWithTranslations(
    "settings, defaultSettings, config, showAdvancedFilter, notificationsSupported, showSuccessMessage",
    actions
)(DesktopFilter);
